import { useTranslation } from "react-i18next";
import { List } from "react-native-paper";
import Box from "../Box";
import MarkdownRenderer from "../MarkdownRenderer";
import RedeemableProductListItem from "../RedeemableProductListItem";
import type { RedeemStatus, RedeemablePurchase } from "./types";

type Props = {
	purchases: RedeemablePurchase[];
	email: string;
	redeemStatus?: RedeemStatus;
	selectedProducts: string[];
	onSelectProduct: (id: string) => void;
	redeemedProductsExamName: string;
};

export const AutoRedeemContentView = ({
	purchases,
	email,
	redeemStatus,
	selectedProducts,
	onSelectProduct,
	redeemedProductsExamName,
}: Props) => {
	const { t } = useTranslation();
	const numPurchases = purchases.length;

	const hasRedeemed = redeemStatus === "redeemed";
	const isRedeeming = redeemStatus === "redeeming";

	const messageText = hasRedeemed
		? t("autoRedeem.successMessage", {
				count: numPurchases,
				examName: redeemedProductsExamName,
			})
		: t("autoRedeem.unredeemedPrompt", {
				count: numPurchases,
				email,
			});

	return (
		<Box gap={4}>
			<Box paddingHorizontal={16}>
				<MarkdownRenderer
					text={messageText}
					variant="stem"
					textAlign="center"
				/>
			</Box>

			<List.Section>
				{purchases.map((purchase) => (
					<RedeemableProductListItem
						key={purchase.id}
						title={purchase.title}
						icon={purchase.icon}
						hasRedeemed={hasRedeemed}
						disabled={isRedeeming}
						description={purchase.description}
						selected={selectedProducts.includes(purchase.id)}
						handleSelectProduct={() => onSelectProduct(purchase.id)}
					/>
				))}
			</List.Section>
		</Box>
	);
};
